import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "content", "checkbox", "agreeButton"];
  static values = {
    enforceRead: Boolean,
    tooltipText: String,
  };

  connect() {
    this.contentTarget.addEventListener("scroll", this.checkScroll);
    this.hasScrolledToBottom = false;
    this.handleClickOutside = (event) => {
      if (this.modalTarget.classList.contains("hidden")) return;

      if (event.target === this.modalTarget) {
        this.close();
      }
    };
    document.addEventListener("click", this.handleClickOutside);

    if (this.enforceReadValue) {
      this.checkboxTarget.checked = false;
      this.checkboxTarget.classList.add("tooltip");
      this.checkboxTarget.setAttribute("aria-label", this.tooltipTextValue);
      this.checkboxTarget.setAttribute("data-balloon-pos", "up-left");
      this.agreeButtonTarget.disabled = true;
      this.checkboxTarget.addEventListener("change", this.uncheckCheckbox);
    } else {
      this.agreeButtonTarget.disabled = false;
      this.hasScrolledToBottom = true;
      this.checkboxTarget.classList.remove("tooltip");
      this.checkboxTarget.removeAttribute("aria-label");
      this.checkboxTarget.removeAttribute("data-balloon-pos");
    }
  }

  disconnect() {
    this.contentTarget.removeEventListener("scroll", this.checkScroll);
    document.removeEventListener("click", this.handleClickOutside);
  }

  open(event) {
    event.preventDefault();
    this.modalTarget.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
    this.checkScroll();
  }

  close() {
    this.modalTarget.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  }

  agree() {
    this.checkboxTarget.removeEventListener("change", this.uncheckCheckbox);
    this.checkboxTarget.checked = true;
    this.checkboxTarget.classList.remove("tooltip");
    this.checkboxTarget.removeAttribute("aria-label");
    this.checkboxTarget.removeAttribute("data-balloon-pos");
    this.close();
  }

  checkScroll = () => {
    if (!this.enforceReadValue) return;

    const content = this.contentTarget;

    if (this.hasScrolledToBottom) {
      this.agreeButtonTarget.disabled = false;
      return;
    }

    if (content.scrollHeight <= content.clientHeight) {
      this.agreeButtonTarget.disabled = false;
      this.hasScrolledToBottom = true;
      return;
    }

    const isAtBottom =
      Math.abs(content.scrollHeight - content.scrollTop - content.clientHeight) < 5;

    if (isAtBottom) {
      this.agreeButtonTarget.disabled = false;
      this.hasScrolledToBottom = true;
    } else {
      this.agreeButtonTarget.disabled = true;
    }
  };

  uncheckCheckbox = () => {
    this.checkboxTarget.checked = false;
  };
}
